import SettingsPageComponent from '../../components/SettingsPageComponent';

const SettingsPage = () => {
  return <SettingsPageComponent />;
};

export default SettingsPage;
